<template>
    <div>
        <v-card-text>
            <!--            <v-flex xs12>-->
            <!--                <v-alert-->
            <!--                        type="info"-->
            <!--                >-->
            <!--                    <b>FOR ADDING SRE (SINGLE RE-ENTRY) OR MRE (MULTIPLE RE-ENTRY) TO CURRENT VISA</b>-->
            <!--                </v-alert>-->
            <!--            </v-flex>-->
            <v-alert
                    type="info"
                    v-if="extendConvertVisaDetail.visaPlan !== 3"
                    outlined>
                Your visa plan upgrade cost from {{current_visa_plan(extendConvertVisaDetail.visa_plan)}} to
                {{current_visa_plan(extendConvertData.visaPlan)}} will
                be {{cost}} USD
            </v-alert>
            {{extendConvertVisaDetail.visaPlan}}
            <v-alert
                    type="success"
                    v-if="extendConvertVisaDetail.visaPlan === 3"
                    outlined>
                Your visa already has Multiple Re-Entry plan.
            </v-alert>
            <v-flex xs12>
                <v-radio-group row v-model="extendConvertData.visaPlan">
                    <v-radio :value="2" label="Update to SRE (Single Re-entry)"
                             v-if="show_sre"/>
                    <v-radio :value="3" label="Update to  MRE (Multiple Re-entry)"
                             v-if="show_mre"/>
                </v-radio-group>
            </v-flex>
        </v-card-text>
        <v-card-actions class="d-flex"  v-if="extendConvertVisaDetail.visaPlan !== 3">
            <v-spacer/>
            <v-btn
                    color="error"
                    @click="proceed"
                    large
            >
                {{$vuetify.lang.t('$vuetify.back')}}
            </v-btn>
            <v-btn
                    color="primary"
                    @click="proceed"
                    large
            >
                {{$vuetify.lang.t('$vuetify.proceed')}}
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "PlanUpgradeForm",
        computed: {
            ...mapGetters('VisaSingle', ['extendConvertData', 'extendConvertVisaDetail']),
            show_sre() {
                return parseInt(this.extendConvertVisaDetail.visa_plan) === 1;
            },
            show_mre() {
                return parseInt(this.extendConvertVisaDetail.visa_plan) === 1 || parseInt(this.extendConvertVisaDetail.visa_plan) === 2;
            },
            cost() {
                if (this.extendConvertData.visaPlan === 2)
                    return this.extendConvertVisaDetail.sre_cost;

                if (this.extendConvertData.visaPlan === 3)
                    return this.extendConvertVisaDetail.mre_cost;

                return 'n/a';
            }
        },
        methods: {
            proceed() {
                this.extendConvertData.update_cost = this.cost;
                this.$router.push({
                    name: 'VisaUpgradeConfirm'
                })
            },
            backBtnClicked() {
                this.$router.go(-1);
            },
            current_visa_plan(visaPlan) {
                if (visaPlan === 1)
                    return 'Plain';

                else if (visaPlan === 2)
                    return 'Single Re-Entry (SRE)';

                else
                    return 'Multiple Re-Entry (MRE)';
            }
        }
    }
</script>
